// // Helper function to set a cookie
// if (!document.cookie.includes('countryValueDomain')) {

//     function setCookie(name, value, days, domain) {
//         const date = new Date();
//         date.setTime(date.getTime() + days  * 24 * 60  * 60 * 1000);
//         const expires = `expires=${date.toUTCString()}`;
//         const domainAttr = domain ? `; domain=${domain}` : '';
//         document.cookie = `${name}=${value}; ${expires}; path=/ ${domainAttr}`;
//     }
    
//     // Helper function to get a cookie by name
//     function getCookie(name) {
//         const cookies = document.cookie.split(';');
//         for (let cookie of cookies) {
//             const [key, value] = cookie.trim().split('=');
//             if (key === name) return value;
//         }
//         return null;
//     }
    
//     // Country redirects map
//     const countryRedirects = {
//         "UK": "https://azha-uk.myshopify.com",
//         "QA": "https://azha-qat.myshopify.com",
//         "KW": "https://azha-kw.myshopify.com",
//         "OM": "https://azha-om.myshopify.com",
//         "BH": "https://azha-bh.myshopify.com",
//         "SA": "https://azha-ksa.myshopify.com",
//         "AE": "https://azha-uae.myshopify.com",
//         "US": "https://azhausa.com",
//         "NL": "https://uae.azhaperfumes.com",
//         "BE": "https://uae.azhaperfumes.com",
//         "BG": "https://uae.azhaperfumes.com",
//         "CY": "https://uae.azhaperfumes.com",
//         "DK": "https://uae.azhaperfumes.com",
//         "DE": "https://uae.azhaperfumes.com",
//         "EE": "https://uae.azhaperfumes.com",
//         "FI": "https://uae.azhaperfumes.com",
//         "FR": "https://uae.azhaperfumes.com",
//         "GR": "https://uae.azhaperfumes.com",
//         "HU": "https://uae.azhaperfumes.com",
//         "IE": "https://uae.azhaperfumes.com",
//         "IT": "https://uae.azhaperfumes.com",
//         "HR": "https://uae.azhaperfumes.com",
//         "LV": "https://uae.azhaperfumes.com",
//         "LU": "https://uae.azhaperfumes.com",
//         "MT": "https://uae.azhaperfumes.com",
//         "AT": "https://uae.azhaperfumes.com",
//         "PL": "https://uae.azhaperfumes.com",
//         "PT": "https://uae.azhaperfumes.com",
//         "RO": "https://uae.azhaperfumes.com",
//         "SI": "https://uae.azhaperfumes.com",
//         "SK": "https://uae.azhaperfumes.com",
//         "ES": "https://uae.azhaperfumes.com",
//         "CZ": "https://uae.azhaperfumes.com",
//         "SE": "https://uae.azhaperfumes.com",
//         "CH": "https://uae.azhaperfumes.com",
//         "NO": "https://uae.azhaperfumes.com",
//         "BA": "https://uae.azhaperfumes.com",
//         "IS": "https://uae.azhaperfumes.com",
//         "LI": "https://uae.azhaperfumes.com",
//         "MC": "https://uae.azhaperfumes.com",
//         "RS": "https://uae.azhaperfumes.com",
//         "AU": "https://uae.azhaperfumes.com",
//         "BR": "https://uae.azhaperfumes.com",
//         "CA": "https://uae.azhaperfumes.com",
//         "CN": "https://uae.azhaperfumes.com",
//         "HK": "https://uae.azhaperfumes.com",
//         "JP": "https://uae.azhaperfumes.com",
//         "NZ": "https://uae.azhaperfumes.com",
//         "AE":  "www.azhaperfumes.com",
//         "AE":  "www.azhaperfumes.ae",
//         "AE":"https://uae.azhaperfumes.com"
//     };
    
//     // Check if a country cookie exists
//     const countryCodeCookie = getCookie('countryCodes');
   
    
//     if (countryCodeCookie) {
//         // Redirect based on cookie value
//         const redirectUrl = countryRedirects[countryCodeCookie];
//         if (redirectUrl) {
//             console.log(`Redirecting to ${redirectUrl} based on cookie.`);
//             if(countryCode!==customCountryValue){
//             window.location.href = redirectUrl;
//             }
//         } else {
//             console.log("No redirection available for this country.");
//         }
//     } else {
//         // Fetch country code from IPWHOIS API
//         $.getJSON("https://ipwhois.app/json/", function (data) {
//             const countryCode = data.country_code;
//             const redirectUrl = countryRedirects[countryCode];
//             let customCountryValue = document.getElementById("hon-country-localization__disclosure-button").querySelector('p').innerHTML ;
//             if (redirectUrl) {
//                 // Set a cookie for future visits (valid for 30 days, across all subdomains)
//                 setCookie('countryCodes', countryCode, 30, '.azhaperfumes.com');
//                 console.log(`Redirecting to ${redirectUrl} based on API data.`);
//                 if(countryCode!==customCountryValue){
//                     window.location.href = redirectUrl;
//                 }
//             } else {
//                 console.log("No redirection available for this country.");
//             }
//         }).fail(function () {
//             console.error("Failed to fetch geolocation data.");
//         });
//     }
    
    
//     }
   
const countryRedirects = {
    "UK": "uae.azhaperfumes.com",
    "QA": "uae.azhaperfumes.com",
    "KW": "uae.azhaperfumes.com",
    "OM": "om.azhaperfumes.com",
    "BH": "bh.azhaperfumes.com",
    "SA": "ksa.azhaperfumes.com",
    "AE": "uae.azhaperfumes.com",
    "US": "azhausa.com",
    "NL": "uae.azhaperfumes.com",
    "BE": "uae.azhaperfumes.com",
    "BG": "uae.azhaperfumes.com",
    "CY": "uae.azhaperfumes.com",
    "DK": "uae.azhaperfumes.com",
    "DE": "uae.azhaperfumes.com",
    "EE": "uae.azhaperfumes.com",
    "FI": "uae.azhaperfumes.com",
    "FR": "uae.azhaperfumes.com",
    "GR": "uae.azhaperfumes.com",
    "HU": "uae.azhaperfumes.com",
    "IE": "uae.azhaperfumes.com",
    "IT": "uae.azhaperfumes.com",
    "HR": "uae.azhaperfumes.com",
    "LV": "uae.azhaperfumes.com",
    "LU": "uae.azhaperfumes.com",
    "MT": "uae.azhaperfumes.com",
    "AT": "uae.azhaperfumes.com",
    "PL": "uae.azhaperfumes.com",
    "PT": "uae.azhaperfumes.com",
    "RO": "uae.azhaperfumes.com",
    "SI": "uae.azhaperfumes.com",
    "SK": "uae.azhaperfumes.com",
    "ES": "uae.azhaperfumes.com",
    "CZ": "uae.azhaperfumes.com",
    "SE": "uae.azhaperfumes.com",
    "CH": "uae.azhaperfumes.com",
    "NO": "uae.azhaperfumes.com",
    "BA": "uae.azhaperfumes.com",
    "IS": "uae.azhaperfumes.com",
    "LI": "uae.azhaperfumes.com",
    "MC": "uae.azhaperfumes.com",
    "RS": "uae.azhaperfumes.com",
    "AU": "uae.azhaperfumes.com",
    "BR": "uae.azhaperfumes.com",
    "CA": "uae.azhaperfumes.com",
    "CN": "uae.azhaperfumes.com",
    "HK": "uae.azhaperfumes.com",
    "JP": "uae.azhaperfumes.com",
    "NZ": "uae.azhaperfumes.com",
    "AE": "azhaperfumes.com",
    "AE": "azhaperfumes.ae",
    "AE": "uae.azhaperfumes.com"
  
  };
  function getCookie(name) {
    const value = `${document.cookie}`;
    const parts = value.split(`; ${name}=`);
  
    if (parts.length > 1) {
      return parts.pop().split(';').shift();
    }
    return null;
  }
  
  if (window.location.hostname === "uae.azhaperfumes.com") {
    let cookieValue = getCookie('countryValue')
    $.getJSON("https://ipapi.co/json/", function (data) {
      console.log("Full Geo API Response:", data); 
      if (!data || !data.country_code) {
          console.error("Invalid response from geolocation API.");
          return;
      }
  
      const countryCode = data.country_code;
      console.log("Detected country code:", countryCode);
  
      if (!['AE'].includes(countryCode)) {
          let cookieValue = getCookie('countryValue');
          console.log("cookieValue:", cookieValue);
  
          const redirectUrl = countryRedirects[countryCode];
          if (redirectUrl && redirectUrl !== window.location.hostname && !['AE'].includes(cookieValue)) {
              console.log(`Redirecting to: ${redirectUrl}`);
              window.location.hostname = redirectUrl;
          } else {
              console.log("No redirection required.");
          }
      }
  }).fail(function () {
      console.error("Failed to fetch geolocation data.");
  });
  
  }
     